import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { MailAccountModel, ConnectMailAccountRequest } from './mail-account.model';

const ENDPOINT = '/mail-accounts';

@Injectable({ providedIn: 'root' })
export class MailAccountsService {

  constructor(private http: HttpClient) { }

  getList(): Promise<MailAccountModel[]> {
    return this.http.get(environment.apiUrl + ENDPOINT)
      .toPromise()
      .then((response: any) => response || [])
      .catch(() => []);
  }

  connect(request: ConnectMailAccountRequest): Promise<MailAccountModel> {
    return this.http.post(environment.apiUrl + ENDPOINT, request)
      .toPromise()
      .then((response: any) => response);
  }

  toggleActive(uid: string, active: boolean): Promise<any> {
    return this.http.put(environment.apiUrl + ENDPOINT + '/' + uid + '/active', { active })
      .toPromise();
  }

  runNow(uid: string): Promise<MailAccountModel> {
    return this.http.post(environment.apiUrl + ENDPOINT + '/' + uid + '/run-now', {})
      .toPromise()
      .then((response: any) => response);
  }

  delete(uid: string): Promise<any> {
    return this.http.delete(environment.apiUrl + ENDPOINT + '/' + uid)
      .toPromise();
  }
}
